import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from '../_reducers/notification.reducers';
import { Notification } from 'src/app/notification/models/notification.model';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../_base/crud';

export const selectNotificationState = createFeatureSelector<NotificationState>('notifications');

export const selectNotificationPageLoading = createSelector(
  selectNotificationState,
  (state) => state.pageLoading,
);

export const selectNotificationActionLoading = createSelector(
  selectNotificationState,
  (state) => state.actionLoading,
);

export const selectNotificationShowInitWaitingMessage = createSelector(
  selectNotificationState,
  (state) => state.showInitWaitingMessage,
);

export const selectNotificationError = createSelector(
  selectNotificationState,
  (state) => state.error,
);

export const selectNotificationsPage = createSelector(selectNotificationState, (state) => {
  const notifications: Notification[] = [];
  each(state.ids, (id: number) => notifications.push(state.entities[id]));

  return new QueryResultsModel(notifications, state.totalCount);
});
